module.exports = __webpack_public_path__ + "img/complementary-care-select-en.77e2c060.jpg";